export enum PermissionList {
  MassCancellation = 543,
  SendGroupMessage = 481
}
